export interface CongressBase {
  id: string;
  name: string;
  date: string;
  active: boolean;
  requireVoterRegistration: boolean;
  voterRegistrationActive: boolean;
  votingCodeAtRegistration: boolean;
  vouchers: string[];
}

export const congressBaseFields = `
  id
  name
  date
  active
  requireVoterRegistration
  voterRegistrationActive
  votingCodeAtRegistration
  vouchers
`;

export interface CongressInput {
  name: string;
  date: string;
  active: boolean;
  requireVoterRegistration: boolean;
  voterRegistrationActive: boolean;
  votingCodeAtRegistration: boolean;
  vouchers?: string[];
}

export const congressInputFieldNames = [
  'name',
  'date',
  'active',
  'requireVoterRegistration',
  'voterRegistrationActive',
  'votingCodeAtRegistration',
  'vouchers',
] as const;
